import { Alert, Box, Button, Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import { Helmet } from 'react-helmet';
import ConfirmationFR from '../images/ConfirmationFR.svg';
import ConfirmationEN from '../images/ConfirmationEN.svg';
import { useState } from 'react';
import { SendActivationEmail } from 'services/profile/ProfileService';
import LoadingIndicator from 'components/common/LoadingIndicator';

const ActivateAccount = (): JSX.Element => {
  const { t } = useTranslation('component');
  const [errorMessages, setErrorMessage] = useState('');
  const [saveMessage, setSaveMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const queryParameters = new URLSearchParams(window.location.search);
  const email = queryParameters.get('email');

  const SendEmailConfirmationEmail = async () => {
    setIsLoading(true);
    setSaveMessage('');
    setErrorMessage('');

    if (!email) setErrorMessage('Errors.MissingEmail');
    else {
      try {
        await SendActivationEmail(email);
        setSaveMessage('ActivateAccount.SuccessMessage');
      } catch {
        setErrorMessage('Errors.GenericError');
      }
    }

    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.ActivateAccountTitle')}</title>
        <meta name="description" content={t('MetaTag.ActivateAccountDescription').toString()} />
      </Helmet>
      <Box
        sx={{
          minHeight: { xs: '0', md: '45em' },
          width: { xs: 'none', md: 562 },
          padding: { xs: '2em 0 2em', md: '56px 0 56px' },
          margin: { xs: '0', md: '0 auto' },
        }}>
        {errorMessages && (
          <Alert id="pageErrorMessage" severity="error" sx={{ mb: '25px' }}>
            {t(errorMessages)}
          </Alert>
        )}
        {saveMessage && (
          <Alert id="pageSuccessMessage" severity="success" sx={{ mb: '25px' }}>
            {t(saveMessage, { email: email })}
          </Alert>
        )}

        <Card>
          <CardMedia component="img" image={i18n.resolvedLanguage == 'fr' ? ConfirmationFR : ConfirmationEN} />
          <CardContent sx={{ textAlign: 'center', my: 2 }}>
            <Typography display="block" variant="h1">
              {t('ActivateAccount.Title')}
            </Typography>
            <Typography display="block" variant="body1" sx={{ m: 2, mx: 4 }}>
              {t('ActivateAccount.Description')}
            </Typography>

            <Typography display="block" variant="body2" sx={{ mb: '1em', mt: '2em' }}>
              {t('ActivateAccount.NotReceived')}
            </Typography>

            <Grid display={'inline-flex'}>
              {isLoading && <LoadingIndicator sx={{ marginRight: '25px' }} />}
              <Button disabled={isLoading} onClick={SendEmailConfirmationEmail} size="large" variant="contained">
                {t('ActivateAccount.SendNewEmail')}
              </Button>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default ActivateAccount;
